import { Component, computed, input } from '@angular/core';
import { AbstractControl, FormControl, FormControlStatus } from '@angular/forms';
import { TranslationKey } from 'src/app/core/services/translater';
import { formValidationCommonErrorsMap } from '@shared/consts';
import { FormErrorKind } from '@common/enums';

const ERROR_PRIORITY_ORDER: FormErrorKind[] = [
  FormErrorKind.REQUIRED,
  FormErrorKind.NOT_EMPTY_STRING,
  FormErrorKind.NOT_EMPTY_ARRAY,
  FormErrorKind.PATTERN,
  FormErrorKind.POSITIVE,
  FormErrorKind.REGISTER_NUMBER,
  FormErrorKind.DATE_IN_PAST,
  FormErrorKind.DATE_IN_FUTURE,
  FormErrorKind.UNVALID_RANGE_START,
  FormErrorKind.UNVALID_RANGE_END,
];

@Component({
  selector: 'idel-form-error',
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss',
})
export class FormErrorComponent {
  public readonly errorMessage = input<string>('');
  public readonly control = input<FormControl>();

  public readonly activeErrorKey = computed<TranslationKey | null>(() => {
    const control = this.control();

    if (!control) return null;

    const { errors, touched, valid } = control;

    if (!errors || valid || !touched) return null;

    for (const key of ERROR_PRIORITY_ORDER) {
      if (errors[key]) return formValidationCommonErrorsMap.get(key) ?? null;
    }

    const fallbackKey = Object.keys(errors)[0];
    return formValidationCommonErrorsMap.get(fallbackKey) ?? null;
  });
}
